<div class="services-page-component-wrapper">
  <section class="services-hero">
    <div *ngFor="let color of bgColors"
      [style.background-color]="color" class="colored-box">
    </div>
    <div class="hero-texts">
      <h1>Atrizult Consult</h1>
      <div class="hero-bottom-text">
        <div class="orange-line"></div>
        <span>{{ "services-page.heroText" | translate }}</span>
        <div class="orange-line"></div>
      </div>
    </div>
    <img src="{{ heroImage }}" alt="Man with arms folded" loading="lazy" />
  </section>

  <section class="services-article" id="services">
    <h2 class="section-title">
      <span *ngFor="let word of (sectionTitle | translate).split(' ')">{{
        word
      }}</span>
    </h2>

    <p class="services-section-para">
      {{ "services-page.details" | translate }}
    </p>
    <app-image-text-card-wrapper
      class="service-cards-wrapper"
      [services]="services"
    />
  </section>
</div>
